'use client';

import { useOpalContext } from 'src/providers/OpalProvider';

import Image from 'next/image';
import {
  userSignIn,
  userSignOut,
} from 'src/helpers/utilities/auth/azureConnect';
import styles from './SiteHeader.module.scss';

function SiteHeader({ session }) {
  const { title, setTitle } = useOpalContext();
  return (
    <header className={styles.header}>
      <Image
        alt="Opal Logo"
        height={60}
        priority
        src="https://cisassets.blob.core.windows.net/opal-page-assets/Opal_temp_Logo_150px.png"
        width={62}
      />

      <div className={styles.heading}>
        <div style={{ float: 'left' }}>{title}</div>
        {session ? (
          <div>
            <button
              className={styles.btnSignIn}
              type="button"
              onClick={() => userSignOut()}
            >
              Sign out
            </button>
            {/*<span className={styles.user}>{session.user.name} ({session.user.email})</span>*/}
          </div>
        ) : (
          <button
            className={styles.btnSignIn}
            type="button"
            onClick={() => userSignIn()}
          >
            Sign in
          </button>
        )}
      </div>
    </header>
  );
}

export default SiteHeader;
